<template>
    <div
        class="el-grid-card el-material-manager-grid el-grid-card--white"
        style="width: 100%"
    >
        <div class="el-grid-card__body">
            <el-row class="flex justify-between items-center filter-block">
                <v-flex xs12 sm6 md3 v-if="isBLCNotificationList">
                    <v-text-field
                        :label="$t('form.label.search')"
                        v-model="searchTerm"
                        append-icon="search"
                        class="el-light-search"
                    ></v-text-field>
                </v-flex>
            </el-row>

            <el-row>
                <el-table
                    class="el-table__dark-expandable"
                    ref="materialsTable"
                    :data="searchResults"
                    row-key="BLCNotificationID"
                    v-loading="loading"
                    style="width: 100%"
                    @row-click="rowClicked"
                    @expand-change="expandMaterials"
                    border
                >
                    <el-table-column
                        min-width="85"
                        sortable
                        :label="$t('table.column.express')"
                        prop="IsExpress"
                    >
                        <template slot-scope="{ row }">
                            <ul class="express-icon-list" v-if="row.IsExpress">
                                <li class="express-icon"></li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="180"
                        sortable
                        :label="$t('table.column.status')"
                        prop="StatusDescription"
                    >
                        <template slot-scope="{ row }">
                            {{
                                $t(`status.${row.StatusDescription}`) ||
                                    row.StatusDescription
                            }}
                            <img
                                v-if="checkImages(row)"
                                src="/images/icon/images-icon-black.png"
                                style="width: 20px;right: 10px;position: absolute;"
                            />
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="135"
                        sortable
                        :label="$t('table.column.stockOrder')"
                        prop="IsStockOrder"
                    >
                        <template slot-scope="{ row }">
                            {{
                                row.IsStockOrder
                                    ? $t('text.yes')
                                    : $t('text.no')
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        min-width="250"
                        sortable
                        :label="$t('table.column.estArrivalBLC')"
                        :sort-method="
                            (a, b) => sortByDate(a, b, 'estimatedArrival')
                        "
                        prop="estimatedArrival"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="250"
                        sortable
                        :label="$t('table.column.destination')"
                        prop="DestinationContainer"
                    >
                    </el-table-column>
                    <el-table-column
                        min-width="250"
                        v-if="hasDescription"
                        :label="$t('table.column.latestEvent')"
                    >
                        <template slot-scope="{ row }">
                            <div
                                v-for="(description, i) in row.descriptions"
                                :key="i"
                            >
                                {{ description }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :resizable="false" type="expand">
                        <stc-blc-notification
                            slot-scope="{ row }"
                            :key="row.BLCNotificationID"
                            :data-notification="row"
                            :show-extra-fields="!isBlc"
                            :suppliers="suppliers"
                            :readonly="
                                !(
                                    'CREATED' === row.StatusDescription ||
                                    (isBlc &&
                                        'ARRIVED_BLC' === row.StatusDescription)
                                )
                            "
                            :isInventory="true"
                            @delete-notification="deleteNotification"
                            @notification-to-stock="notificationToStock"
                            @item-create="() => updateView()"
                            @item-update="() => updateView()"
                            @item-delete="() => updateView()"
                            @package-create="() => updateView()"
                            @package-update="() => updateView()"
                            @package-delete="() => updateView()"
                            @item-move-to-store="() => updateView()"
                            @notification-update="updateView"
                        >
                        </stc-blc-notification>
                    </el-table-column>
                </el-table>
            </el-row>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import StcBlcNotification from '../../components/blc/material-manager/BlcNotification'
import InteractWithSort from '../../mixins/interact-with-sort'
import InteractWithDates from '../../mixins/interact-with-dates'
import BookingCreate from '../bookings/BookingCreate'
import StcDialog from '../Dialog'

export default {
    name: 'inventory-list',

    props: {
        withPermission: {
            type: Boolean,
            default: true,
        },
        isBLCNotificationList: {
            type: Boolean,
            default: true,
        },
        notification: {
            type: Object,
            default: undefined,
        },
        dateRange: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: false,
            bookingCreateComponent: '',
            activeButton: 0,
            dateTimeRange: [],
            data: [],
            container: '',
            hasDescription: false,
            suppliers: [],
            searchTerm: '',
            searchResults: [],
            showCreateBookingBtn: true,
            notificationType: 'DEFAULT',
            createBookingDialog: false,
        }
    },

    components: {
        'stc-blc-notification': StcBlcNotification,
        'stc-dialog': StcDialog,
        'stc-booking-create': BookingCreate,
    },

    mixins: [InteractWithDates, InteractWithSort],

    created() {
        // Create Booking Notification Success event listener
        Events.$on('booking-create-success', res => {
            if (this.createBookingDialog) {
                this.createBookingDialog = false
                this.bookingCreateComponent = ''
                // this.dateTimeRange = res
                this.refreshTable()
            }
        })

        if (this.withPermission) {
            this.redirectIfNotBlc()
        }

        if (this.isBLCNotificationList) {
            this.fetch(
                this.selectedContainer,
                this.dateRange,
                true,
                this.selectedContainer.ContainerType
            )
        } else {
            if (this.notification) {
                this.fetchByBLCNotificationIDAndContainerID(
                    this.notification.bLCNotificationID,
                    this.notification.containerID
                )
            }
        }
    },
    beforeDestroy() {
        Events.$off('booking-create-success')
    },
    watch: {
        selectedContainer: function(container) {
            if (this.withPermission) {
                this.redirectIfNotBlc()
            }
            this.fetch(container, this.dateTimeRange)
        },

        searchTerm: _.debounce(async function() {
            if (this.searchTerm !== '') {
                this.searchResults = await this.$search(
                    this.searchTerm,
                    this.notifications,
                    this.searchOptions
                )
            } else {
                this.searchResults = this.notifications
            }
        }, 500),
    },
    computed: {
        ...mapGetters(['isBlc', 'selectedContainer']),

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        notifications() {
            this.hasDescription = false

            let data = this.data
            if (!this.withPermission) {
                data = data.filter(item => item.DeletedStatus !== 98)
            }

            return data.map(item => {
                let actualArrival = ''
                if (item.ActualArrival) {
                    actualArrival = DateTime.fromISO(
                        item.ActualArrival
                    ).toLocaleString(DateTime.DATETIME_MED)
                }

                let estimatedArrival = DateTime.fromISO(
                    item.EstimatedArrival
                ).toLocaleString(DateTime)

                let descriptions = []

                if (item.Actors && item.Actors.length) {
                    descriptions = item.Actors.map(actor => {
                        if (actor.DeliveredDate !== null) {
                            let deliveredDate = DateTime.fromISO(
                                actor.DeliveredDate
                            ).toLocaleString(DateTime.DATETIME_MED)

                            return `Material delivered with ${
                                actor.BookingReference
                            } (Delivered on ${deliveredDate})`
                        }

                        let plannedDeliveryDate = DateTime.fromISO(
                            actor.PlannedDelivery
                        ).toLocaleString(DateTime.DATETIME_MED)

                        return `Material added to ${
                            actor.BookingReference
                        } (Planned delivery ${plannedDeliveryDate})`
                    })

                    this.hasDescription = true
                }

                return {
                    actualArrival,
                    estimatedArrival,
                    descriptions,
                    ...item,
                }
            })
        },

        searchOptions() {
            return {
                keys: [
                    'DestinationContainer',
                    'PackageGroups.Reference',
                    'PackageGroups.OrderNo',
                    'PackageGroups.SupplierName',
                    'Actors.PackageGroups.Reference',
                    'Actors.PackageGroups.OrderNo',
                    'Actors.PackageGroups.SupplierName',
                ],
            }
        },
    },

    methods: {
        expandMaterials(row) {
            this.fetchSuppliers(row.DestinationContainerID)
        },

        redirectIfNotBlc() {
            if (!this.isBlc) {
                this.$router.push({ name: 'dashboard' })
            }
        },

        fetchByDateTimeRange(range) {
            this.activeButton = ''
            this.fetch(this.selectedContainer, range)
        },

        async deleteNotification(notification) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'notification',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                if (
                    this.selectedContainer &&
                    this.selectedContainer.ContainerType === 'CCC'
                ) {
                    await this.$http.delete(
                        `/BLC/${
                            this.selectedContainer.ContainerID
                        }/Notification/${notification.BLCNotificationID}`
                    )
                } else {
                    await this.$http.delete(
                        `/Container/${
                            this.selectedContainer.ContainerID
                        }/Notification/${notification.BLCNotificationID}`
                    )
                }

                // Refresh Calendar
                Events.$emit('notification-deleted', notification)

                // Refresh Material List Table
                await this.fetch(
                    this.selectedContainer,
                    this.dateTimeRange,
                    true,
                    this.selectedContainer.ContainerType
                )

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'notification',
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        async notificationToStock(notification) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.moveToStock'),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let container = this.selectedContainer

                if (this.container) {
                    container = await this.fetchContainerBlcData(this.container)
                }

                const updateStatuses = _.chain(
                    notification.PackageGroups
                ).flatMap(packageGroup => {
                    return packageGroup.PackageItems.map(item => {
                        return this.$http.put(
                            `/BLC/${container.ContainerID}/Notification/${
                                notification.BLCNotificationID
                            }/PackageGroup/${
                                packageGroup.PackageGroupID
                            }/PackageItem/${
                                item.PackageItemID
                            }/Status/HIDDEN_INVENTORY_TO_STOCK`
                        )
                    })
                })

                await Promise.all(updateStatuses)

                Events.$emit('notification-to-stock', notification)

                await this.refreshTable()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.success.moveToStock'
                    ),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        async fetch(
            container = null,
            range = [],
            loading = true,
            type = 'CCC'
        ) {
            this.loading = loading

            container = container ? container : this.selectedContainer

            if (!_.isEmpty(container)) {
                range = range.length ? range : this.withinDay

                let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

                let dateTimeFrom = DateTime.fromISO(range[0].toISOString())
                let dateTimeTo = DateTime.fromISO(range[1].toISOString())

                // set end and start time to day start and day end if it doesn't contains time
                if (
                    dateTimeFrom.startOf('day').valueOf() ===
                        dateTimeFrom.valueOf() &&
                    dateTimeTo.startOf('day').valueOf() === dateTimeTo.valueOf()
                ) {
                    let start = dateTimeFrom.startOf('day')
                    let end = dateTimeTo.endOf('day')

                    dateTimeFrom = start.toFormat(dateTimeFormat)
                    dateTimeTo = end.toFormat(dateTimeFormat)

                    range = [start.toJSDate(), end.toJSDate()]
                } else {
                    dateTimeFrom = dateTimeFrom.toFormat(dateTimeFormat)
                    dateTimeTo = dateTimeTo.toFormat(dateTimeFormat)
                }

                if ('CCC' === type) {
                    let { data } = await this.$http.post(`/BLC/Notification/PackageItemStatus`, {
                        "BlcContainerID":container.ContainerID,
                        "Status" : 98,
                        "CurrentPage":1,
                        "PageSize":20
                    })
                    this.data = data.result
                } else {
                    let { data } = await this.$http.get(
                        `/Container/${
                            container.ContainerID
                        }/BLCNotification/From/${dateTimeFrom}/To/${dateTimeTo}`
                    )
                    this.data = data
                }

                this.searchResults = this.notifications
                this.checkImages(this.notifications)
                this.dateTimeRange = range
            }

            this.loading = false
        },
        async fetchByBLCNotificationIDAndContainerID(
            bLCNotificationID,
            bLCContainerID
        ) {
            this.loading = true
            let { data } = await this.$http.get(
                `/BLC/${bLCContainerID}/Notification/${bLCNotificationID}`
            )
            this.loading = false
            if (data) {
                this.data = []
                this.data.push(data)
                this.searchResults = this.notifications
                this.expandTableRow()
            }
        },
        refreshTable() {
            if (this.container) {
                this.fetch(
                    this.container,
                    this.dateTimeRange,
                    false,
                    'Container'
                )
            } else {
                this.fetch(this.selectedContainer, this.dateTimeRange, false)
            }
        },
        rowClicked(row) {
            if (this.isBLCNotificationList) {
                this.$refs.materialsTable.toggleRowExpansion(row)
            }
        },
        async fetchSuppliers(container = null) {
            container = container || this.selectedContainer
            const containerId = _.isObject(container)
                ? container.ContainerID
                : container

            let { data } = await this.$http.get(
                `Container/${containerId}/Supplier`
            )
            data.sort( (a, b) => {
                if(a && b && a.SupplierName && b.SupplierName){
                    return a.SupplierName.localeCompare(b.SupplierName, 'en', {numeric: true})
                }          
            });
            this.suppliers = data
        },
        expandTableRow() {
            this.$nextTick(() => {
                this.$el
                    .getElementsByClassName('el-table__expand-icon ')[0]
                    .click()
                this.$el.getElementsByClassName(
                    'el-table__expand-icon '
                )[0].style.display = 'none'
            })
        },
        openCreateBookingDialog() {
            this.bookingCreateComponent = 'stc-booking-create'
            this.createBookingDialog = true
        },
        closeCreateBookingDialog() {
            this.createBookingDialog = false
            this.bookingCreateComponent = ''
        },
        updateView() {
            if (this.isBLCNotificationList) {
                // 'dateRange' is a custom date range prop for this component
                if (this.dateRange.length === 2) {
                    this.fetch(
                        this.selectedContainer,
                        this.dateRange,
                        false,
                        this.selectedContainer.ContainerType
                    )
                } else {
                    this.refreshTable()
                }
            }
        },
        checkImages(notitifcation) {
            if (
                notitifcation.PackageGroups &&
                notitifcation.PackageGroups.length > 0
            ) {
                for (const group of notitifcation.PackageGroups) {
                    if (group && group.Images && group.Images.length > 0) {
                        return true
                    }
                }
            }
        },
    },
}
</script>
